import { getBlogUrl } from '@change-corgi/config/blog';
import { getFacebookVanity } from '@change-corgi/config/facebook';
import { getInstagramHandle } from '@change-corgi/config/instagram';
import { getTiktokHandle } from '@change-corgi/config/tiktok';
import { getTwitterHandle } from '@change-corgi/config/twitter';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useCountryCode, useLocale } from '#src/app/shared/hooks/l10n';

import { processLinkGroup } from './processLinkGroup';
import type { LinkGroup } from './types';

export function useFollowUsLinks(): LinkGroup | null {
	const { translate } = useI18n();
	const countryCode = useCountryCode();
	const locale = useLocale();
	const twitterHandle = getTwitterHandle({ locale, countryCode });
	const facebookVanity = getFacebookVanity({ locale, countryCode });
	const instagramHandle = getInstagramHandle({ locale, countryCode });
	const tiktokHandle = getTiktokHandle({ locale, countryCode });

	return processLinkGroup({
		title: translate('corgi.components.footer.section.follow_us'),
		links: [
			{
				href: `https://www.instagram.com/${instagramHandle}`,
				title: translate('corgi.components.footer.links.instagram'),
				target: '_blank',
			},
			{
				href: `https://twitter.com/${twitterHandle}`,
				title: translate('corgi.components.footer.links.x'),
				target: '_blank',
			},
			{
				href: `https://www.facebook.com/${facebookVanity}`,
				title: translate('corgi.components.footer.links.facebook'),
				target: '_blank',
			},
			{
				href: `https://www.tiktok.com/@${tiktokHandle}`,
				title: translate('corgi.components.footer.links.tiktok'),
				target: '_blank',
			},
			{
				href: getBlogUrl({ locale, countryCode }),
				title: translate('corgi.components.footer.links.blog'),
			},
		],
	});
}
